import { format$Price, formatPrice } from "utils/helpers/functions/formatPrice";
import { withLocalCurrency } from "utils/helpers/currency/currencyHelpers";
import vconst from "utils/helpers/structs/vconst";
import TableEmptyRow from "components/others/TableEmptyRow";
import { UserNameItem } from 'modules/user';
import { DateTime as DT } from "luxon";
import ExpendOtherActions from "./ExpendOtherActions";
import { Button } from "react-bootstrap";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { tDirName } from "utils/helpers/i18n/tDirName";
import { stripHtmlToText } from "utils/helpers/functions/stripHtml";
import SolarIcon from 'components/icons/SolarIcon';
  
const ExpendOtherTableBody = ({expends, setShowSpinnerExpend, setShowExpendInfo, onlyView = false}) => {
    
    const { t } = useTranslation(['Objects']);
    const refBtnView = useRef();
    
    return ( 
        <tbody>
            {expends?.map(expend=>{
                const dt = DT.fromMillis(expend.dt||0).toLocaleString(DT.DATE_MED);
                const rawAmount = Number(expend.expendAmount) || 0;
                const rawAmountRate = Number(expend.expendAmountRate) || 0;
                const amount = format$Price(rawAmount, true);
                const amountRate = formatPrice(rawAmountRate);
                const amountClass = rawAmount > 0 ? 'text-success' : 'text-danger';
                const description = stripHtmlToText(expend.expendDescription || '');
                
                return (
                    <tr className={`${expend.expendStatus === vconst.incomeStatCancel ? 'bg-light-danger' :''}`}
                        key={expend.ID}>
                        <td className="user">
                            <UserNameItem
                                smallMode
                                user={{
                                    userName       : expend.userName,
                                    userEmail      : expend.userEmail,
                                    userPicture    : expend.userPicture
                                }}/>
                        </td>
                        <td className="team">
                            <h6 className={`mb-1 text-break `}>{tDirName(t, expend.i18nKey, expend.expendName)}</h6>
                            {description ? (
                            <p className="text-muted f-12 mb-0 my-1 text-truncate" title={description}>
                                {description}
                            </p>
                            ) : null}
                            {onlyView ? (
                            <div>
                                <p className="text-muted f-12 mb-0 my-1">{dt}</p>
                            </div>
                            ) : null}
                        </td>
                        <td className="amount">
                            {expend.expendStatus === vconst.incomeStatCancel 
                            ?(<h6 className={`mb-1 text-truncate text-muted`}>{amount}</h6>)
                            :(<h6 className={`mb-1 text-truncate ${amountClass}`}>{amount}</h6>)}
                            <p className="text-muted f-12 mb-0 my-1 text-truncate">{withLocalCurrency(amountRate)}</p> 
                        </td>
                        <td className="actions">
                        {onlyView 
                            ? (<>
                            <Button
                                className="p-1 py-0" 
                                ref={refBtnView}
                                size="sm" 
                                variant="light-secondary" 
                                onClick={(e)=>{
                                    e.target?.blur();
                                    e.target?.parentNode?.blur();
                                    refBtnView?.current?.blur();
                                    setShowExpendInfo(expend.ID)
                                }}><SolarIcon name="eye" /></Button>
                            </>)
                            :(<ExpendOtherActions 
                                setShowExpendInfo={setShowExpendInfo}
                                setShowSpinnerExpend={setShowSpinnerExpend}
                                expend={expend}/>)} 
                        </td>
                    </tr>
                )
            })}

            {(!expends || expends?.length === 0) && (
                <TableEmptyRow colSpan={4} />
            )}
        </tbody>
    )
}

export default ExpendOtherTableBody;